/* ============================================
   XenGolf Modal Styling - Consistent with Tables, Cards & Accordions
   ============================================ */

/* Modal container */
.xenGolfModal {
    /* Optional: Custom modal styling */
}

/* Modal content wrapper */
.xenGolfModalContent {
    border-radius: var(--radius-md);
}

/* Modal header - dark theme matching tables, cards, and accordions */
.xenGolfModalHeader {
    background-color: var(--color-bg-dark, var(--color-gray-900)) !important;
    color: white !important;
    border-bottom: none !important;
    padding: 16px 20px !important;
}

/* Modal title styling */
.xenGolfModalTitle {
    color: white !important;
    font-weight: var(--font-weight-semibold, 600);
    text-transform: uppercase;
    font-size: var(--font-size-lg, 1.125rem);
    letter-spacing: 0.5px;
    margin: 0;
}

/* Close button styling - white to match header */
.xenGolfModalHeader :global(.btn-close) {
    filter: brightness(0) invert(1) !important;
    opacity: 0.8;
}

.xenGolfModalHeader :global(.btn-close:hover) {
    opacity: 1;
}

/* Modal body styling */
.xenGolfModalBody {
    background-color: white;
    padding: 20px;
}

/* Modal footer styling */
.xenGolfModalFooter {
    background-color: white;
    padding: 16px 20px;
    border-top: 1px solid var(--color-border-light);
}

/* ============================================
   Modal Variants
   ============================================ */

/* Compact variant - less padding */
.xenGolfModalCompact .xenGolfModalHeader {
    padding: 12px 16px !important;
}

.xenGolfModalCompact .xenGolfModalBody {
    padding: 16px;
}

.xenGolfModalCompact .xenGolfModalFooter {
    padding: 12px 16px;
}

/* Flush variant - remove shadow */
.xenGolfModalFlush .xenGolfModalContent {
    box-shadow: none;
}

/* ============================================
   Mobile Optimizations
   ============================================ */

@media (max-width: 767px) {
    .xenGolfModalHeader {
        padding: 12px 16px !important;
    }

    .xenGolfModalTitle {
        font-size: 10px;
    }

    .xenGolfModalBody {
        padding: 16px;
        font-size: var(--font-size-xs, 0.75rem);
    }

    .xenGolfModalFooter {
        padding: 12px 16px;
    }
}


/* For a confirm modal stacked on top of another modal:
   - lift the backdrop above the underlying modal (default modal z-index
     is 1055, default backdrop is 1050, so the backdrop alone can't dim
     the underlying modal) and darken it
   - lift the confirm modal above its own boosted backdrop */
.stackedConfirmBackdrop {
    --bs-backdrop-opacity: 0.85;
    z-index: 1065 !important;
}

.stackedConfirmModal {
    z-index: 1070 !important;
}

